import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

const About = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>About Hospital Build Pvt Ltd | Medical Gas Pipeline Experts</title>
        <meta name="description" content="Learn about Hospital Build Pvt Ltd, a trusted leader in Medical Gas Pipeline Systems (MGPS) and hospital infrastructure solutions in India." />
        <meta name="keywords" content="About Hospital Build, Medical Gas Pipeline Experts, MGPS Company India, Hospital Infrastructure, Healthcare Solutions" />
        <link rel="canonical" href="https://www.hospitalbuild.in/about" />
      </Helmet>
      {/* Hero Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
        <div className="relative h-[360px] rounded-lg overflow-hidden">
          <img
            src="/images/about-hero.svg"
            alt="About Us"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#2C2C90]/80 rounded-lg"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-6xl font-bold text-white">About Us</h1>
          </div>
        </div>

        <div className="flex flex-col justify-center">
          <h2 className="text-4xl font-bold text-[#2C2C90] mb-8">
            Trusted Medical Gas Pipeline Specialists
          </h2>
          <div className="space-y-6">
            <p className="text-gray-700 text-lg leading-relaxed">
              Hospital Build (Formerly Hospital Build) is one of the leading manufacturers & suppliers of Medical Gas Pipeline System (MGPS). We take special care that Medical Gas Pipeline Systems (MGPS) is a patient's life support and its designing & installation require a precise technical expertise. Thus, continual skill development and innovation is central to our organization.
            </p>
            <p className="text-gray-700 text-lg leading-relaxed">
              Employing technological expertise in design and development of newer products for critical application we have carved out a special space in the Medical Gas Pipeline Systems (MGPS) industry which has led us to succeed in Indian & Foreign markets.
            </p>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="border border-[#2C2C90] rounded-lg p-8 text-center"
        >
          <div className="text-[#2C2C90] mb-4">
            <svg className="w-16 h-16 mx-auto" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm-4 9h8v-2H8v2z" />
            </svg>            
          </div>
          <h3 className="text-2xl font-semibold text-[#2C2C90] mb-4">Established in 1996</h3>
          <p className="text-gray-600">
            The company is now entering its 28th year and is proud of its growth and extended reputation as a major player in the worldwide family of Medical Gas Pipeline installers and users.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="border border-[#2C2C90] rounded-lg p-8 text-center"
        >
          <div className="text-[#2C2C90] mb-4">
            <svg className="w-16 h-16 mx-auto" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
            </svg>
          </div>
          <h3 className="text-2xl font-semibold text-[#2C2C90] mb-4">Globally Recognised</h3>
          <p className="text-gray-600">
            We supply 90% of the India market and export to over 75 countries worldwide. Growth has been structured to meet our customers needs both in the India and the expanding overseas markets.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="border border-[#2C2C90] rounded-lg p-8 text-center"
        >
          <div className="text-[#2C2C90] mb-4">
            <svg className="w-16 h-16 mx-auto" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.88-11.71L10 14.17l-1.88-1.88a.996.996 0 1 0-1.41 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7a.996.996 0 1 0-1.41-1.41z" />
            </svg>
          </div>
          <h3 className="text-2xl font-semibold text-[#2C2C90] mb-4">Our Brand</h3>
          <p className="text-gray-600">
            The Hospital Build brand is a proudly owned trademark of Hospital Build All Hospital Build products are distinctly marked with this brand name, reflecting our commitment to exceptional design and quality.
          </p>
        </motion.div>
      </div>
      {/* Certifications Section */}
      <div>
        <h2 className="text-4xl font-bold text-[#2C2C90] text-center mb-8">
          Our Vision & Mission
        </h2>
        <p className="text-gray-700 text-lg text-center mb-12">
          <span className="font-semibold">Vision:</span> To be the world's most trusted and innovative provider of medical gas pipeline systems, setting the benchmark for safety, reliability, and excellence in healthcare infrastructure. We envision a future where every hospital, clinic, and healthcare facility—regardless of location—has access to state-of-the-art medical gas solutions that empower caregivers and protect patient lives.
        </p>
        <p className="text-gray-700 text-lg text-center mb-12">
          <span className="font-semibold">Mission:</span> Our mission is to design, manufacture, and deliver advanced medical gas pipeline systems and solutions that exceed international standards. We are committed to continuous innovation, rigorous quality control, and ethical business practices. By fostering a culture of learning, collaboration, and customer focus, we aim to support healthcare professionals in saving lives and improving patient outcomes. We strive to expand our global reach, build lasting partnerships, and contribute to a healthier, safer world—one facility at a time.
        </p>
      </div>

      {/* Leaders Section */}
      <div className="mb-16">
        <h2 className="text-4xl font-bold text-[#2C2C90] text-center mb-8">
          Our Leaders: The Driving Force Behind Our Success
        </h2>
        <p className="text-gray-700 text-lg text-center mb-12">
          At Hospital Build, our journey has been shaped and elevated by the visionary leadership of Patel, Anjoo Patel, and Atul Verma. Their unwavering dedication, passion, and commitment to excellence have propelled our company to new heights in the medical gas pipeline industry. Through their relentless focus on quality, innovation, and customer satisfaction, they have fostered a culture where every team member is inspired to strive for greatness. Their expertise and guidance have not only driven our success but have also empowered us to deliver exceptional results for our clients and partners. Under their direction, we continuously push boundaries, embrace new opportunities, and set higher standards for ourselves, ensuring that Hospital Build remains a trusted and leading name in the industry for years to come.
        </p>

        <div className="flex flex-col gap-12 mb-12">
          {/* Leader 1 */}
          <div className="w-full flex justify-start">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="flex flex-col md:flex-row items-center bg-white rounded-lg shadow p-8 w-full lg:w-10/12"
            >
              <div className="flex flex-col items-center mb-6 md:mb-0 md:mr-8">
                <img
                  src="/images/profile/p2.jpg"
                  alt="Patel"
                  className="w-48 h-48 rounded-full object-cover bg-gray-100 mb-4"
                />
                <h3 className="text-2xl font-semibold mb-2">Patel</h3>
                <p className="text-gray-600 mb-4">Founder</p>
              </div>
              <div className="flex-1">
                <blockquote className="italic text-lg text-[#2C2C90] border-l-4 border-[#2C2C90] pl-4">
                  "Innovation and integrity are the cornerstones of our journey. At Hospital Build, we believe that true progress is achieved not just by adopting the latest technologies, but by fostering a culture of honesty, transparency, and continuous improvement. Every challenge we face is an opportunity to learn and grow, and every success is a testament to the dedication of our team. Our commitment to quality and ethical business practices has enabled us to build lasting relationships with our clients and partners. As we look to the future, we remain steadfast in our mission to deliver excellence in every project, ensuring the well-being of patients and the trust of healthcare professionals worldwide."
                </blockquote>
              </div>
            </motion.div>
          </div>

          {/* Leader 2 */}
          <div className="w-full flex justify-end">
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="flex flex-col md:flex-row-reverse items-center bg-white rounded-lg shadow p-8 w-full lg:w-10/12"
            >
              <div className="flex flex-col items-center mb-6 md:mb-0 md:ml-8">
                <img
                  src="/images/profile/p1.jpg"
                  alt="Anjoo Patel"
                  className="w-48 h-36 rounded-full object-cover bg-gray-100 mb-4"
                />
                <h3 className="text-2xl font-semibold mb-2">Anjoo Patel</h3>
                <p className="text-gray-600 mb-4">Co-Founder</p>
              </div>
              <div className="flex-1">
                <blockquote className="italic text-lg text-[#2C2C90] border-l-4 border-[#2C2C90] pl-4">
                  "Quality and customer satisfaction drive every decision we make. Our journey has been defined by a relentless pursuit of excellence, where every product and service is crafted with the utmost care and attention to detail. We understand that our work directly impacts the lives of patients and healthcare providers, which is why we never compromise on standards. Listening to our customers, understanding their unique needs, and exceeding their expectations are at the heart of our philosophy. Through teamwork, innovation, and a passion for service, we strive to set new benchmarks in the industry and create value for all our stakeholders."
                </blockquote>
              </div>
            </motion.div>
          </div>

          {/* Leader 3 */}
          <div className="w-full flex justify-start">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
              className="flex flex-col md:flex-row items-center bg-white rounded-lg shadow p-8 w-full lg:w-10/12"
            >
              <div className="flex flex-col items-center mb-6 md:mb-0 md:mr-8">
                <img
                  src="/images/profile/p3.jpg"
                  alt="Atul Verma"
                  className="w-48 h-48 rounded-full object-cover bg-gray-100 mb-4"
                />
                <h3 className="text-2xl font-semibold mb-2">Atul Verma</h3>
                <p className="text-gray-600 mb-4">Director</p>
              </div>
              <div className="flex-1">
                <blockquote className="italic text-lg text-[#2C2C90] border-l-4 border-[#2C2C90] pl-4">
                  "Our team's passion and expertise are the foundation of our success. At Hospital Build, we recognize that it is the collective effort, creativity, and dedication of our people that enable us to achieve our goals. We encourage open communication, continuous learning, and a spirit of collaboration that empowers everyone to contribute their best. By nurturing talent and fostering a supportive environment, we are able to overcome challenges and seize new opportunities. Our vision is to inspire and lead by example, ensuring that our company remains a trusted partner in the healthcare industry for generations to come."
                </blockquote>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="bg-[#2C2C90] text-white p-8 rounded-lg">
          <p className="mb-4">Since its inception in 1996, Hospital Build has been guided by the visionary leadership of Patel, Atul Verma, and Anjoo Patel. Their unwavering commitment to stringent quality control and innovation has ensured the consistent delivery of world-class medical gas pipeline systems (MGPS) and solutions.</p>
          <p className="mb-4">Through strong principles, integrity, and a passion for excellence, our leaders have built lasting relationships with vendors and partners across the globe. Today, Hospital Build's MGPS products are highly regarded and widely sought after by corporates, government hospitals, and medical institutions both in India and internationally.</p>
          <p className="mb-4">Our reputation for technological excellence and reliability has earned us a place on the approved vendor lists of BOC India Limited and other leading multinational corporations, further validating our commitment to quality and trust.</p>
          <p className="mb-4">The remarkable acclaim and success of Hospital Build are a direct reflection of the visionary leadership, innovative prowess, and collaborative spirit of Patel, Atul Verma, and Anjoo Patel.</p>
          <p>May our founders and leaders continue to inspire, guide, and shape the future of Hospital Build for generations to come.</p>
        </div>
      </div>


    </div>
  );
};

export default About; 
